import type { QueryClient } from '@tanstack/svelte-query';
import {
	getGetTrackersApiTrackersGetQueryKey,
	getGetTrackerApiTrackersTrackerIdGetQueryKey,
	getGetArchivedTrackersApiTrackersArchivedGetQueryKey,
	getGetTrashedTrackersApiTrackersTrashGetQueryKey,
	getGetTrackersOverviewApiTrackersOverviewGetQueryKey,
	getGetTrackerStatsApiTrackersTrackerIdStatsGetQueryKey,
	getGetTrackerHeatmapApiTrackersTrackerIdHeatmapGetQueryKey
} from '$lib/api/generated/trackers/trackers';
import { getGetSuggestionsApiSuggestionsGetQueryKey } from '$lib/api/generated/suggestions/suggestions';
import { getGetFavoritesApiFavoritesGetQueryKey } from '$lib/api/generated/favorites/favorites';

/**
 * Invalidate all tracker-related queries.
 * Use after tracker create/update/delete/archive/restore.
 */
export function invalidateTrackerQueries(queryClient: QueryClient, trackerId?: string) {
	queryClient.invalidateQueries({
		queryKey: getGetTrackersApiTrackersGetQueryKey(),
		refetchType: 'active'
	});
	queryClient.invalidateQueries({
		queryKey: getGetTrackersOverviewApiTrackersOverviewGetQueryKey(),
		refetchType: 'active'
	});
	queryClient.invalidateQueries({
		queryKey: getGetArchivedTrackersApiTrackersArchivedGetQueryKey(),
		refetchType: 'active'
	});
	queryClient.invalidateQueries({
		queryKey: getGetTrashedTrackersApiTrackersTrashGetQueryKey(),
		refetchType: 'active'
	});
	queryClient.invalidateQueries({
		queryKey: getGetSuggestionsApiSuggestionsGetQueryKey(),
		refetchType: 'active'
	});
	queryClient.invalidateQueries({
		queryKey: getGetFavoritesApiFavoritesGetQueryKey(),
		refetchType: 'active'
	});

	if (trackerId) {
		queryClient.invalidateQueries({
			queryKey: getGetTrackerApiTrackersTrackerIdGetQueryKey(trackerId)
		});
		queryClient.invalidateQueries({
			queryKey: getGetTrackerStatsApiTrackersTrackerIdStatsGetQueryKey(trackerId)
		});
		queryClient.invalidateQueries({
			queryKey: getGetTrackerHeatmapApiTrackersTrackerIdHeatmapGetQueryKey(trackerId)
		});
	}
}
